<template>
  <shipblu-prompt
    class="shipment-modal"
    @close="closeStockRequestModal"
    :active.sync="uploadStockRequestModal"
    :title="$t(uploadTitle)"
    :buttons-hidden="true">
    <div class="text-center mt-5">
      <a :href="file_URl" class="text-blue-100 underline inline-block mt-1" target="blank">{{ $t('Download Template') }}</a>
    </div>
    <div class="excel-import">
      <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
      <div
        @click="$refs.fileInput.click()"
        @drop="handleDrop"
        @dragover="handleDragover"
        @dragenter="handleDragover"
        class="w-1/2 m-auto mt-10 mb-10 px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
        <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
        <span>{{ $t('Drop Excel File or') }} </span>
        <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">{{ $t('Browse') }}</span>
      </div>
    </div>
  </shipblu-prompt>
</template>

<script>
import ShipbluPrompt from '../../../../layouts/components/ShipBluPrompt.vue'

export default {
  props: {
    uploadStockRequestModal: Boolean,
    uploadType: {
      type: String,
      default: 'stock-request'
    }
  },
  data () {
    return {
      file_URl: 'https://staging-publicstorage1123538a-1p8k71zpb6h3c.s3.eu-west-3.amazonaws.com/Stock+Request+Upload.xlsx'
    }
  },
  computed: {
    uploadTitle () {
      return this.uploadType === 'stock-recall' ? 'Upload Stock Recall' : 'Upload Stock Request'
    }
  },
  methods: {
    closeStockRequestModal () {
      this.$emit('uploadStockRequestModal', false)
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.selectFile(rawFile)
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: this.$t('Warning'),
          text: this.$t('Only support uploading one file!'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: this.$t('Warning'),
          text: this.$t('Only supports upload .xlsx, .xls suffix files'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.selectFile(rawFile)
    },
    isExcel (file) {
      return /\.(xlsx|xls)$/i.test(file ? file.name : '')
    },
    selectFile (rawFile) {
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          color: 'warning',
          title: this.$t('Warning'),
          text: this.$t('Only supports upload .xlsx, .xls suffix files'),
          position: 'top-center'
        })
        return
      }
      this.$refs['fileInput'].value = null // fix can't select the same excel twice
      this.$emit('uploaded', rawFile)
      this.$emit('uploadStockRequestModal', false)
    }
  },
  components: {
    ShipbluPrompt
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>
